import { useState } from 'react';
import { resetAppOnThisDevice } from '../lib/appRecovery';

const pageStyle = {
  minHeight: '100vh',
  background: '#081525',
  color: '#f0f2f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 20,
  boxSizing: 'border-box',
  fontFamily: "'DM Sans', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
};

const panelStyle = {
  width: '100%',
  maxWidth: 460,
  border: '1px solid #30404e',
  borderRadius: 8,
  background: '#0a1b36',
  padding: 22,
  boxSizing: 'border-box',
};

const buttonStyle = {
  width: '100%',
  border: 'none',
  borderRadius: 8,
  padding: '13px 16px',
  fontSize: 15,
  fontWeight: 900,
  fontFamily: "'DM Sans', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  cursor: 'pointer',
};

export default function ResetPage() {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleReset = async () => {
    if (status === 'working') return;
    setStatus('working');
    setMessage('Resetting this device...');
    const result = await resetAppOnThisDevice();
    setMessage(`Reset complete. Cleared ${result.cachesCleared} cache(s), removed ${result.serviceWorkersRemoved} service worker(s), and cleared local app state.`);
    setStatus('done');
    window.setTimeout(() => {
      window.location.replace('/');
    }, 900);
  };

  return (
    <main style={pageStyle}>
      <section style={panelStyle} aria-labelledby="reset-title">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
          <div style={{
            width: 34,
            height: 34,
            borderRadius: 8,
            background: 'linear-gradient(145deg, #c0a060, #8a7040, #a89050)',
            color: '#081525',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 900,
            flexShrink: 0,
          }}>
            S
          </div>
          <div>
            <div style={{ color: '#d4a84a', fontSize: 11, fontWeight: 900, textTransform: 'uppercase' }}>
              SiteScope
            </div>
            <h1 id="reset-title" style={{ margin: 0, fontSize: 22, lineHeight: 1.15, letterSpacing: 0 }}>
              Reset this device
            </h1>
          </div>
        </div>

        <p style={{ color: '#a8b8cc', fontSize: 14, lineHeight: 1.5, margin: '0 0 18px' }}>
          Use this when SiteScope keeps showing stale data, will not load, or feels stuck on this device.
        </p>

        <div style={{
          border: '1px solid #263653',
          borderRadius: 8,
          padding: 12,
          color: '#a8b8cc',
          fontSize: 13,
          lineHeight: 1.45,
          marginBottom: 16,
        }}>
          This clears local app storage, cached files, and the service worker. It does not change server data, billing, tracked DAs, notes, or your account.
        </div>

        <div style={{ display: 'grid', gap: 10 }}>
          <button
            onClick={handleReset}
            disabled={status === 'working'}
            style={{
              ...buttonStyle,
              background: status === 'working' ? '#8a7040' : '#d4a84a',
              color: '#081525',
              opacity: status === 'working' ? 0.75 : 1,
            }}
          >
            {status === 'working' ? 'Resetting...' : status === 'done' ? 'Opening SiteScope...' : 'Reset and reopen'}
          </button>
          <button
            onClick={() => window.location.assign('/')}
            disabled={status === 'working'}
            style={{
              ...buttonStyle,
              background: 'transparent',
              border: '1px solid #30404e',
              color: '#f0f2f6',
              opacity: status === 'working' ? 0.55 : 1,
            }}
          >
            Open without reset
          </button>
        </div>

        {message && (
          <div role="status" style={{ marginTop: 14, color: status === 'done' ? '#5aba6a' : '#a8b8cc', fontSize: 13, lineHeight: 1.4 }}>
            {message}
          </div>
        )}
      </section>
    </main>
  );
}
